import { curry } from "lodash/fp";
import { Transaction, TransactionStatus } from "../types";
import { getFromLocalStorage, setToLocalStorage } from "@silo/ui";

export const now = () => new Date().getTime();

export const setTransactionStatus = (
  status: TransactionStatus,
  hash: string,
  oldTransactions: Transaction[]
) => {
  const indexToUpdate = oldTransactions.findIndex(({ tx }) => tx.hash === hash);

  if (indexToUpdate < 0) return oldTransactions;

  const transactionToUpdate = oldTransactions[indexToUpdate];

  const updatedTransaction = {
    ...transactionToUpdate,
    status,
  };

  return replaceItemAtIndex(oldTransactions, indexToUpdate, updatedTransaction);
};

export const setTransactionToSuccess = curry(setTransactionStatus)("success");
export const setTransactionToError = curry(setTransactionStatus)("error");

const replaceItemAtIndex = <T>(arr: T[], index: number, newValue: T) => {
  return [...arr.slice(0, index), newValue, ...arr.slice(index + 1)];
};

export const isTransactionPending = ({ status }: Transaction) =>
  status === "pending";

/**
 * Returns whether a transaction happened in the last day (86400 seconds * 1000 milliseconds / second)
 */
export const isTransactionRecent = ({ timeAdded }: Transaction): boolean => {
  return new Date().getTime() - timeAdded < 86_400_000;
};

export const getStoredTransactions = () => {
  const transactions = getFromLocalStorage<Transaction[]>("transactions", []);

  const filteredTransactions = transactions.filter(isTransactionRecent);

  storeTransactions(filteredTransactions);

  return filteredTransactions;
};

export const storeTransactions = (transactions: Transaction[]) => {
  setToLocalStorage("transactions", transactions);
};
